var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Auth',[_c('section',[_c('p',[_vm._v("Recuperar contraseña")])]),_c('footer')])
}
var staticRenderFns = []

export { render, staticRenderFns }